import styled from 'styled-components';
import TextareaAutosize from 'react-autosize-textarea';

export const Wrapper = styled.div`
  width: 100%;
`;

export const Label = styled.span`
  display: block;
  margin-bottom: 3.25rem;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: start;
`;

export const Textarea = styled(TextareaAutosize)`
  width: 100%;
  max-height: 200px;
  border: 1.5px solid darkGray;
  resize: none;
  padding: 0.5rem;
  border-radius: 0.5rem;
  line-height: 1.3;
  font-size: 1rem;
  font-style: inherit;
  outline: 0;
  ::placeholder {
    font-size: 0.75rem;
  }
`;

export const TabsAndTextareaWrapper = styled.div`
  position: relative;
`;

export const TabsWrapper = styled.div`
  position: absolute;
  left: 5px;
  top: 1.5px;
  transform: translateY(-100%);
  display: flex;
`;

export const Tab = styled.div`
  padding: 0.5rem 0.75rem;
  border: 1px solid darkGray;
  border-bottom: ${({ isActive }) => (isActive ? 1.5 : 1)}px solid
    ${({ isActive }) => (isActive ? 'white' : 'darkGray')};
  border-radius: 0.5rem 0.5rem 0 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: gray;
  background-color: ${({ isActive }) => (isActive ? 'white' : 'gainsboro')};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.7)};
  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;
